<template>
  <Modal :modal="modal.filter" :action="() => _trigger()">
    <ModalBody>
      <input
        type="file"
        class="d-none"
        accept=".xlsx,.xls"
        ref="file"
        @change="_onFile"
      />
      <div class="col-12 form-group">
        <template v-if="import_error.length > 0">
          <label for="bulk" class="form-label text-danger">Error Import</label>
          <div class="error-container">
            <table class="table">
              <thead>
                <th v-for="(row, i) in import_error[0]" :key="i" v-html="i" />
              </thead>
              <tbody>
                <tr v-for="(row, i) in import_error" :key="i">
                  <td v-for="(cop, j) in import_error[0]" :key="j">
                    {{ row[j] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <button
          class="btn btn-primary form-control"
          v-html="loading ? spin() : ic('upload') + 'Import Limit'"
          @click="$refs.file.click()"
          :disabled="loading"
        />
      </div>
      <FilterContainer :label="'Restriction'">
        <selectize
          class="form-control"
          v-model="filter.restricted"
          placeholder="Pilih Restriction"
        >
          <option
            v-for="(restriction, i) in restrictions"
            :key="i"
            v-html="restriction.label"
            :value="restriction.value"
          />
        </selectize>
      </FilterContainer>
      <FilterPerusahaan
        :model="filter"
        :response="response"
        :action="() => _getDepo()"
      />
      <FilterDepo
        :model="filter"
        :response="response"
        :action="() => _getSalesman()"
      />
      <FilterSalesman :model="filter" :response="response" />
      <div class="row">
        <label for="bulk" class="form-label">Bulk Update</label>
        <div
          class="col"
          v-for="(row, i) in [
            { label: 'Bulk Rekomendasi', action: 'all' },
            { label: 'Bulk Pengajuan', action: 'pengajuan' },
            { label: 'Bulk Non Pengajuan', action: 'non_pengajuan' },
          ]"
          :key="i"
        >
          <button
            class="btn btn-outline-primary btn-sm form-control"
            v-html="loading ? spin() : row.label"
            :disabled="loading"
            @click="_bulk(row.action)"
          />
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
      <ButtonClose :disabled="loading" :action="() => _trigger()" />
      <ButtonSave :disabled="loading" :action="() => _submit()" />
    </ModalFooter>
  </Modal>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FilterPerusahaan from "@/components/filter/filter-perusahaan.vue";
import FilterDepo from "@/components/filter/filter-depo.vue";
import FilterSalesman from "@/components/filter/filter-salesman.vue";
import FilterContainer from "@/components/filter/filter-container.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    FilterPerusahaan,
    FilterDepo,
    FilterSalesman,
    FilterContainer,
  },
  mixins: [helper],
  data() {
    return {
      import_error: [],
      restrictions: [
        { label: "Show Only in Whitelist", value: "show_only_in_whitelist" },
        { label: "Show Exclude Whitelist", value: "show_exclude_whitelist" },
        { label: "Show Include Whitelist", value: "show_include_whitelist" },
      ],
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("limit_kredit", {
      modal: (state) => state.modal,
      filter: (state) => state.filter,
      response: (state) => state.response,
    }),
  },
  methods: {
    ...mapActions("limit_kredit", [
      "triggerModal",
      "getLimitKredit",
      "updateLimitKreditBulk",
      "updateExcelLimitKredit",
    ]),
    ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
    ...mapActions("depo", ["getListDepo"]),
    ...mapActions("salesman", ["getListSalesman"]),
    _trigger() {
      return this.triggerModal("filter");
    },
    _submit() {
      this.getLimitKredit();
      this._trigger();
    },
    _getPerusahaan() {
      this.getListPerusahaanByAccess().then((res) => {
        this.response.filter.perusahaans = res;
      });
    },
    _getDepo() {
      let id = this.filter.id_perusahaan;
      this.getListDepo({ id_perusahaan: id }).then((res) => {
        this.response.filter.depos = res;
      });
    },
    _getSalesman() {
      let payload = {
        id_depo: this.filter.id_depo,
        id_perusahaan: this.filter.id_perusahaan,
      };
      this.getListSalesman(payload).then((res) => {
        this.response.filter.salesmans = res;
      });
    },
    _onFile(e, params) {
      const files = params == null ? e.target.files : params.files;
      let file = files[0];
      let formData = new FormData();
      formData.append("file", file);
      this.updateExcelLimitKredit(formData).then((res) => {
        this.import_error = res;
      });
    },
    _bulk(payload) {
      this.updateLimitKreditBulk(payload);
    },
  },
  mounted() {
    this._getPerusahaan();
  },
  created() {},
};
</script>
<style scoped>
.error-container {
  max-height: 200px;
  overflow: auto;
}
</style>
